import firebase from "firebase/app";
import "firebase/firestore";

var config = {
  apiKey: "AIzaSyD7KUktZ06vZ70FnVGbnwOPEUqZuebwYlA",
  authDomain: "busineistdirect.firebaseapp.com",
  databaseURL: "https://busineistdirect.firebaseio.com",
  projectId: "busineistdirect",
  storageBucket: "busineistdirect.appspot.com",
  messagingSenderId: "246018845513"
};
firebase.initializeApp(config);

// const firestore = firebase.firestore();
// const settings = { timestampsInSnapshots: true };
// firestore.settings(settings);



// WEBPACK FOOTER //
// ./src/firebase/config.js